
const contant={
  defaultNum:7  //echarts 滚动条 默认七个以上的元素显示滚动条
  }




export default  contant
